import { render } from "./MapSuggest.vue?vue&type=template&id=ab80688e"
import script from "./MapSuggest.vue?vue&type=script&lang=js"
export * from "./MapSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__